// extracted by mini-css-extract-plugin
export default {"container":"ContainerPage_container__36lcw"};